<template>
  <div class="service-area pt--70 pb--50 bg_color--1">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-center section-title mb--30">
            <h2 class="heading-title">Why Work with us</h2>
            <p class="description">
              We are Reliable, Professional and Experienced.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="service-main-wrapper bg-white--service">
        <v-col
          lg="4"
          md="4"
          sm="6"
          cols="12"
          v-for="(listGroup, i) in listInfo"
          :key="i"
        >
          <div class="service service__style--2 text-left bg-gray">
            <div class="service">
              <div class="icon">
                <div v-html="iconSvg(listGroup.icon)"></div>
              </div>
              <div class="content">
                <h3 class="heading-title">{{ listGroup.title }}</h3>
                <ul class="list-style--1">
                  <li
                    class="d-flex"
                    v-for="(item, j) in listGroup.list"
                    :key="j"
                  >
                    <i v-html="iconSvg(item.icon)"></i>
                    {{ item.desc }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import feather from "feather-icons";
export default {
  data() {
    return {
      listInfo: [
        {
          icon: "thumbs-up",
          title: "Reliable",
          list: [
            {
              icon: "check",
              desc: `We guarantee your rent Every month, even when your rooms are empty.`,
            },
          ],
        },
        {
          icon: "users",
          title: "Experienced",
          list: [
            {
              icon: "check",
              desc: `We work with a number of experienced partners, to deliver quality room let accommodation for our clients .`,
            },
            {
              icon: "check",
              desc: `We keep your property in Excellent Condition through fortnightly inspections & cleaning in communal areas.`,
            },
            {
              icon: "check",
              desc: `We give you the freedom from Tenant Management.`,
            },
            {
              icon: "check",
              desc: `We pay your utility bills.`,
            },
          ],
        },
        {
          icon: "layers",
          title: "Professional",
          list: [
            {
              icon: "check",
              desc: `Providing quality accommodation to our end user.`,
            },
          ],
        },
      ],
    };
  },
  methods: {
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
  },
};
</script>
